// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag___3EG9d"};